// FN: 14/07/20
// NOTE:
// This component was built on little sleep and in a rush 😅
// As such it isn't fully implemented. Examples of this include a lack of summary component
// for the summary table as well as missing the fan favourite disabledFieldOptions method

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { VFRadioButtonBase } from './v-f-radio-button-base';
import {
  vFParamsPropShape,
} from './data-structure/v-f-proptypes';
import {
  getFieldPropShape,
  formPropShape,
} from './data-structure/formik-proptypes';
import 'AppSrc/core/style/components/form/form-base-components/v-f-multi-select.css';



const getDisplayTextForValue = ({
  displayOptions,
  selectedValue,
  placeholder,
}) => {
  const selectedDisplayOptions = displayOptions.filter((displayOption) => displayOption.value === selectedValue);
  const selectedDisplayOption = selectedDisplayOptions[0];
  return selectedDisplayOption ? selectedDisplayOption.text : placeholder;
};



class VFRadioButton extends PureComponent {
  constructor(props) {
    super(props);
    this.updateValue = this.updateValue.bind(this);
  }

  updateValue(valueToSet) {
    const {
      field,
      displayOptions,
      vFParams,
      form,
    } = this.props;


    const {
      parseSelectedValue,
    } = vFParams;

    const {
      name,
      value,
    } = field;

    const correctedValue = parseSelectedValue ? parseSelectedValue({
      displayOptions,
      valueToSet,
      // parse selected value also needs access to the original field value
      // so that it can maintain things metadata such as ther readonly flag
      // for approver options
      currentFieldValue: value,
    }) : valueToSet;

    form.setFieldValue(name, correctedValue);
    form.setFieldTouched(name, true);
  }


  render() {

    const {
      displayOptions,
      form,
      field,
      vFParams,
    } = this.props;

    const {
      formatDisplayOptions,
      formatCurrentValue,
      placeholder,
    } = vFParams;

    const {
      name,
      value,
    } = field;

    const formErrors = form.errors;
    const touched = form.touched[name];
    const errors = formErrors[name];

    const formattedDisplayOptions = formatDisplayOptions ? formatDisplayOptions({ displayOptions, value }) : displayOptions;
    const simplifiedValue = formatCurrentValue ? formatCurrentValue({
      value,
      displayOptions,
    }) : value;


    const displayText = getDisplayTextForValue({
      displayOptions: formattedDisplayOptions,
      selectedValue: simplifiedValue,
      placeholder,
    });


    return (
      <VFRadioButtonBase
        displayOptions={formattedDisplayOptions}
        vFParams={vFParams}
        name={name}
        value={simplifiedValue}
        errors={errors}
        touched={touched}
        setValue={this.updateValue}
        displayText={displayText}
      />
    );
  }
}


// This component has full flexibility in terms of what a value or display option can look like
// as such expect to see plenty of PropTypes.any
VFRadioButton.propTypes = {
  vFParams: vFParamsPropShape,
  field: getFieldPropShape(PropTypes.any),
  form: formPropShape,
  displayOptions: PropTypes.arrayOf(PropTypes.any),
  value: PropTypes.arrayOf(PropTypes.any),
  name: PropTypes.string,
  errors: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
  touched: PropTypes.bool,
};


const noValueVFRadioButton = (value) => !value;


// This is a reference to the component. This is needed as the value for each form field is displayed on a change summary
// page but this is dependant on what type of form field is used
const VF_RADIO_BUTTON = 'v-f-radio-button';



export {
  VFRadioButton,
  VF_RADIO_BUTTON,
  noValueVFRadioButton,
};
